export function isTrue(valor) {
  if (valor === 'false') {
    return false;
  }
  return !!valor;
}

export function isFalse(valor) {
  return !isTrue(valor);
}
